/* Whether the logged-in user is an admin, read from what the app keeps in the browser. This only decides what to
   show: the backend checks the admin list on every request, so a wrong answer here cannot grant anything. */

const isAdminFromRoles = (roles: unknown): boolean => {
  const list = Array.isArray(roles) ? roles : roles ? [roles] : [];
  return list.map((r) => String(r || '').toUpperCase()).some((r) => r === 'ADMIN' || r === 'ROLE_ADMIN' || r.includes('ADMIN'));
};

export const parseJwtPayload = (token: string | null | undefined): any | null => {
  if (!token) return null;
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch (_) {
    return null;
  }
};

/** Same rules as the admin route guard in router.tsx. */
export const isAdminFrom = (userDetails: any, jwtPayload: any, contextRoles: unknown = []): boolean =>
  isAdminFromRoles(contextRoles) ||
  isAdminFromRoles(userDetails?.roles) ||
  isAdminFromRoles(userDetails?.role) ||
  isAdminFromRoles(userDetails?.authorities) ||
  String(userDetails?.userType || userDetails?.type || '').toUpperCase().includes('ADMIN') ||
  userDetails?.isAdmin === true ||
  isAdminFromRoles(jwtPayload?.roles) ||
  isAdminFromRoles(jwtPayload?.role) ||
  isAdminFromRoles(jwtPayload?.authorities);

/** Reads the browser's saved login and answers; false when nothing is saved or storage is blocked. */
export const isAdminSession = (storage: Pick<Storage, 'getItem'> | undefined = typeof window !== 'undefined' ? window.localStorage : undefined): boolean => {
  try {
    if (!storage) return false;
    let userDetails: any = null;
    try {
      const raw = storage.getItem('userDetails');
      userDetails = raw ? JSON.parse(raw) : null;
    } catch (_) {
      userDetails = null;
    }
    return isAdminFrom(userDetails, parseJwtPayload(storage.getItem('jwtToken')));
  } catch (_) {
    return false;
  }
};
